//#region libraries
import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
// custom components
import TimelineJobs from "../job-components/timeline-jobs";
import EmployeeList from "../employee-components/employee-list";
import JobConfirmation from "../job-components/job-confirmation";
import TimelineHourRow from "./timeline-hour-row";
import TimelineTitles from "./timeline-titles";
import EditTimelineBooking from "./edit-timeline-booking";
import JobListToolbar from "../job-components/job-list-toolbar";
import ViewJob from "../job-components/view-job";
import { BookingForm, ToolTippy } from '_molecules';
import { CustomToast } from "_atoms";

// live location components
import LiveLocationTab from "../live-locations-components/live-location-tab";

// styling
import styled from "styled-components";
import "./timeline-component.css"
import { Colors } from "_styles";

// bootstrap
import { Col, Row } from "react-bootstrap";

// redux
import { useSelector, useDispatch } from "react-redux";
import { setEmployeeSearch, setEmployeeSearchFilter, resetUpdateEmployeeStatus, selectUpdateEmployeeStatus, updateEmployeeList, selectAllEmployees, setEmployeeConversations, selectSelectedForChat, setSelectedForChat, setEmployeeMessages } from "_redux/slices/timeline/employees";
import {
  updateTaskList,
  resetTimelineToCache,
  resetTimelineData,
  getBookings,
  getDepartureBookings,
  getTaskList,
  acceptUnplannedTask,
  selectDeleteTaskStatus,
  resetDeleteFlags,
  resetBookingByFlightNum,
  setBookingSearch,
  setBookingSearchFilter,
  updateArrivalsTaskList,
  updateDeparturesTaskList,
  selectArrivalsTaskList,
  selectDeparturesTaskList,
  selectBreakTaskList,
  updateBreakTaskList,
  resetPaxCheckInFlags,
  selectPaxCheckOutStatus,
  resetPaxCheckOutFlags,
  selectSetBookingLocationStatus,
  resetSetBookingLocationFlags,
  selectUnRejectPaxStatus
} from "_redux/slices/timeline/timeline-data";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { selectShowConfirmationModal, setViewTask, selectViewTask, reset as resetSelectedTask, resetBreakTaskFlags, selectShowBreakTaskModal, selectSelectedFlightToView, setSelectedFlightToView, selectShowEditModal, selectEditModalType, setShowEditTaskModal } from "_redux/slices/timeline/selected-task";
import { selectBookingType, setPaxLocations, getTimelineAreas, getAirportLocation } from "_redux/slices/timeline/timeline-areas";
import { selectMenuContext, selectMenuPoints, openPaxCheckInModal, selectPaxLocation, selectPaxCheckInModal, reset as resetAllMenuContext, selectShowDeleteBookingModal, selectShowFlightList, setShowFlightList, resetFlightContext, selectFlightContext, selectFlightContextPoints, selectPaxMenuContextModal, selectPaxMenuContext, selectPaxMenuLocationPoints } from "_redux/slices/utils/menu-context";
import { setDashboardEmployeeList, setDashboardTaskList } from "_redux/slices/timeline/timeline-dashboard";
import { getOutboundFlights, getInboundFlights, setSearchedFlight, selectSelectedFlightToChat, setSelectedFlightToChat, resetPassengerFlightList } from '_redux/slices/timeline/flight-information-list';
import { selectShowToast } from "_redux/slices/timeline/timeline-toast";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { setEmployeeLocations } from "_redux/slices/timeline/live-location-tab";

//#endregion

//#region custom components

/* timeline */
import TimelineContainer from "./timeline-container";
import TimelineCard from "./timeline-card";
import TimelineContentContainer from "./timeline-content-container";
import JobActionMenu from "../job-components/job-action-menu";
import TimelineToolbar from "./timeline-toolbar";
import AirportLocations from "../../../../components/organisms/timeline-dashboard/airport-locations";
import NewAirportLocations from "../../../../components/organisms/timeline-dashboard/new-airport-locations";
import TimelineThirtyMinHourRow from "./timeline-thirtyMin-hour-row";
import ViewFlight from "../job-components/view-flight";

/* job list */
import JobListContainer from "../job-components/job-list-container";

// firestore
import { firestore } from "_utils/firebase-app";
import { collection, onSnapshot, query, where } from "firebase/firestore";

// functions 
import { getDate } from "_utils/functions";
import ActionsModal from "_components/molecules/Modals/actions-modal";
import { EmployeeInformationColumnWidthRaw } from "_utils/timeline-constants";
import TimelineSidebar from "./timeline-sidebar";
import { selectAutoAcceptUnplannedTask, selectPreBoard, selectShowTimelineSidebar, selectTimelineDate, setShowTimelineSidebar, setExpandLocations, selectExpandLocations, selectThirtyMinLayout, setShowAllFlights, setTimeLineDate, selectLayout, setThirtyMinLayout, fetchTimelineAppSettings } from "_redux/slices/timeline/timeline-control";
// icons
import { BsLayoutSidebarInsetReverse } from "react-icons/bs";

// resiable
import CreateBreakTask from "./create-break-task";
import DeleteBooking from "./delete-booking";
import FlightList from "../job-components/flight-list";
import FlightActionMenu from "../job-components/flight-action-menu";

// tremor 
import { Button } from '@tremor/react';

// styling
import { Spacing } from "_styles";
import EmployeeChat from "../employee-components/employee-chat";
import FlightChat from "../job-components/flightChat";
import LocationContextMenu from "../job-components/location-context-menu";
import { resetAddFlightPassenger, selectAddFlightPassengerStatus } from "_redux/slices/timeline/timeline-bookings";
import { TIMELINE_V2_AIRPORTS } from "_utils/constants";


const MenuContextContainer = styled.div`
  border-radius: 4px;
  padding: 18px;
  margin: 5px 0;
  box-sizing: border-box;
  z-index: 9999;
  min-width: 250px;
  min-height: 100px;
`;

//#endregion

const TimelineComponent = () => {

  // nav
  const history = useHistory();

  //#region states
  const [clickedColumn, setClickedColumn] = useState(false);                  // holds state of column click
  const [confirmChangeModal, setConfirmChangeModal] = useState(false);        // confirmation of assigning job
  const [showCreateModal, setShowCreateModal] = useState(false);              // holds value to show the create booking modal
  const [timelineHeight, setTimelineHeight] = useState(0)                     // used to monitor height of timeline (timeline card + job list)
  const [touchScreen, setTouchScreen] = useState(false);
  //#endregion

  //#region redux
  const dispatch = useDispatch();

  const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user

  const sliceShowConfirmationModal = useSelector(selectShowConfirmationModal);          // modal to confirm job assignment used for point + click
  const bookingType = useSelector(selectBookingType);                                   // select bookingType (departures,arrivals)
  const autoAcceptUnplannedTask = useSelector(selectAutoAcceptUnplannedTask);           // status of auto accept unplanned task switch
  const deleteTaskStatus = useSelector(selectDeleteTaskStatus);
  const arrivalsTaskList = useSelector(selectArrivalsTaskList);
  const departuresTaskList = useSelector(selectDeparturesTaskList);
  const timelineDate = useSelector(selectTimelineDate);                                 // select timeline Date
  const viewTask = useSelector(selectViewTask);
  const preBoard = useSelector(selectPreBoard);                                         // status of auto accept unplanned task switch
  const breakTaskList = useSelector(selectBreakTaskList);
  const allEmployees = useSelector(selectAllEmployees);
  const selectedForChat = useSelector(selectSelectedForChat);
  const updateEmployeeStatus = useSelector(selectUpdateEmployeeStatus);                 // holds the value of update Employee action status
  const paxCheckInModal = useSelector(selectPaxCheckInModal);                           // holds the value to open and close the pax check in modal
  const paxLocation = useSelector(selectPaxLocation);                                   // holds condition to set the pax check in modal title 

  const setBookingLocationStatus = useSelector(selectSetBookingLocationStatus);         // status set booking location
  const paxCheckOutStatus = useSelector(selectPaxCheckOutStatus);                       // status of passenger check out 
  const showTimelineSidebar = useSelector(selectShowTimelineSidebar);                   // holds value to show timeline sidebar
  const ShowDeleteBookingModal = useSelector(selectShowDeleteBookingModal);             // holds value to show delete booking modal
  const unRejectPaxStatus = useSelector(selectUnRejectPaxStatus);                       // UnReject passenger Status
  const showFlightList = useSelector(selectShowFlightList);
  const toggleAirportLocations = useSelector(selectExpandLocations)
  const thirtyMinLayout = useSelector(selectThirtyMinLayout);

  const flightContext = useSelector(selectFlightContext);
  const flightContextPoints = useSelector(selectFlightContextPoints);

  const selectedFlightToView = useSelector(selectSelectedFlightToView);
  const selectedFlightToChat = useSelector(selectSelectedFlightToChat);
  const usedTheme = useSelector(selectUsedTheme);
  const showEditModal = useSelector(selectShowEditModal);
  const modalType = useSelector(selectEditModalType);
  // menu context
  const showMenuContext = useSelector(selectMenuContext);
  const points = useSelector(selectMenuPoints);
  const showBreakTaskModal = useSelector(selectShowBreakTaskModal);

  //location card menu
  const paxMenuContextModal = useSelector(selectPaxMenuContextModal)
  const passenger = useSelector(selectPaxMenuContext)
  const menuLocationPoints = useSelector(selectPaxMenuLocationPoints)

  // toast 
  const showToast = useSelector(selectShowToast);

  const layout = useSelector(selectLayout)
  const addFlightPassengerStatus = useSelector(selectAddFlightPassengerStatus);
  //#endregion

  //#region functions

  const closeConfirmationModal = () => {
    // stop showing modal
    setConfirmChangeModal(false);
    // reset selected task data
    dispatch(resetSelectedTask());
  };

  const closeCreateBookingModal = () => {
    // stop showing create booking modal
    setShowCreateModal(false);
  };

  const closeEditBookingModal = () => {
    // stop showing edit booking modal
    dispatch(setShowEditTaskModal(false))
  };

  const closePaxCheckInModal = () => {
    // stop showing passenger check in modal
    dispatch(openPaxCheckInModal(false));

  };

  const closeDeleteBookingModal = () => {
    // stop showing passenger check in modal
    dispatch(resetAllMenuContext());
  };

  const closeFlightListModal = () => {
    dispatch(setShowFlightList(false));
  }

  const closeViewFlightModal = () => {
    dispatch(setSelectedFlightToView(null));
    dispatch(resetPassengerFlightList());
  };

  const closeSelectedForChatModal = () => {
    dispatch(setSelectedForChat(null));
    dispatch(setEmployeeMessages([]));
  };

  const closeSelectedFlightToChatModal = () => {
    dispatch(setSelectedFlightToChat(null));

  };

  const closeViewTaskModal = () => {
    dispatch(setViewTask(false));
  };

  const closeBreakTaskModal = () => {
    dispatch(resetBreakTaskFlags())
  }

  const cancelTask = () => {
    setConfirmChangeModal(false);
    // reset selected task data
    dispatch(resetSelectedTask());
    // need to reset timeline cache
    dispatch(resetTimelineToCache());
  };

  // get arrivals bookings
  const handleGetArrivalsBookings = () => {
    const date = getDate(timelineDate);

    dispatch(
      getBookings({
        iata: dbUser.details.authority,
        type: "inbound",
        start: date,
        end: date,
        skip: 0,
        limit: 1000,
        source: "none",
      })
    );
  };

  // get departures bookings
  const handleGetDeparturesBookings = () => {
    const date = getDate(timelineDate);

    dispatch(
      getDepartureBookings({
        iata: dbUser.details.authority,
        type: "outbound",
        start: date,
        end: date,
        skip: 0,
        limit: 1000,
        source: "none",
      })
    );
  };

  const handelGetBookings = () => {
    if (bookingType?.includes("departures") || bookingType?.includes("all")) {
      handleGetDeparturesBookings();
    }
    if (bookingType?.includes("arrivals") || bookingType?.includes("all")) {
      handleGetArrivalsBookings();
    }

  }

  // get flight list
  const handelGetFlights = () => {
    const date = getDate(timelineDate);
    dispatch(getOutboundFlights({ iata: dbUser.details.authority, date: date }))
    dispatch(getInboundFlights({ iata: dbUser.details.authority, date: date }))
  }
  useEffect(() => {
    if (addFlightPassengerStatus === "succeeded") {
      setShowCreateModal(false);
      handelGetBookings();
      dispatch(resetAddFlightPassenger())
    }
  }, [addFlightPassengerStatus])

  //#endregion

  //#region use effects
  // on render fetch all required timeline data
  useEffect(() => {

    if (TIMELINE_V2_AIRPORTS.includes(dbUser.details.authority)) {
      history.push("/timeline-v2");
    }
    // dispatch(setRowsPerPage(5));

    // on render get list of timeline areas from back end and reset time line data flags
    dispatch(getTimelineAreas(dbUser.details.authority));

    // on render get list of locations from back end
    dispatch(getAirportLocation(dbUser.details.authority));

    // load app settings so QR-shift gating (hide portal login/logout) is known
    dispatch(fetchTimelineAppSettings(dbUser.details.authority));

    // reset timeline data object
    dispatch(resetTimelineData());

    // reset selected task data
    dispatch(resetSelectedTask());

    // dispatch(getEmployeeList(dbUser.details.authority));

    // get task list
    dispatch(getTaskList(dbUser.details.authority));

    // get all tasks list

    // reset booking by flight number 
    dispatch(resetBookingByFlightNum());
    // reset employee search filter 
    dispatch(setEmployeeSearch(""));

    // reset booking search filters
    dispatch(setBookingSearch(""));
    dispatch(setBookingSearchFilter('flight'));
    dispatch(setEmployeeSearchFilter('name'));
    dispatch(setSearchedFlight(""));
    dispatch(resetFlightContext());
    dispatch(setSelectedFlightToView(null));
    dispatch(setSelectedForChat(null));


    // dispatch(setEmployeeFilter("online"));


    // reset break task flags
    dispatch(resetBreakTaskFlags());
    scrollToPosition();
    // reset passenger check in modal 
    dispatch(openPaxCheckInModal(false));
    dispatch(resetPaxCheckInFlags());
    dispatch(resetPaxCheckOutFlags());
    dispatch(setShowTimelineSidebar(false));
    dispatch(resetAllMenuContext());
    dispatch(resetSetBookingLocationFlags());
    dispatch(setTimeLineDate(new Date()));
    dispatch(setSelectedFlightToChat(null));
    dispatch(resetPassengerFlightList());
    dispatch(setThirtyMinLayout(false));


  }, []);

  // employee database listener
  useEffect(() => {
    const employeeCollectionRef = collection(firestore, "employee");
    const employeeQuery = query(employeeCollectionRef, where("airport", "==", dbUser.details.authority));

    const unsubscribe = onSnapshot(employeeQuery, (snapshot) => {
      const updatedEmployeeList = [];
      snapshot.forEach((doc) => {
        const employeeData = doc.data();
        if (employeeData.airport == dbUser.details.authority) {
          updatedEmployeeList.push(employeeData);
        }
      });
      dispatch(updateEmployeeList(updatedEmployeeList));
      dispatch(setDashboardEmployeeList(updatedEmployeeList));

    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!dbUser?.details?.authority) return;

    const iata = dbUser.details.authority;
    const onlineEmployees = allEmployees?.filter((emp) => emp?.status !== "offline")?.map((emp) => emp?.employeeId);

    if (!onlineEmployees || onlineEmployees.length === 0) {
      return;
    }

    const empConversationsCollectionRef = collection(firestore, "employeeConversations");

    // Firestore limits array-contains-any to 30 values, so we need to batch
    const BATCH_SIZE = 30;
    const batches = [];

    for (let i = 0; i < onlineEmployees.length; i += BATCH_SIZE) {
      batches.push(onlineEmployees.slice(i, i + BATCH_SIZE));
    }

    const unsubscribers = [];

    batches.forEach((batch) => {
      const conversationsQuery = query(
        empConversationsCollectionRef,
        where("iata", "==", iata),
        where("participantIds", "array-contains-any", batch)
      );

      const unsubscribe = onSnapshot(conversationsQuery, (querySnapshot) => {
        const conversations = [];
        querySnapshot.forEach((doc) => {
          const convData = doc.data();
          conversations.push(convData);
        });
        // Note: This will update for each batch - you may want to aggregate results
        dispatch(setEmployeeConversations(Array.isFullArray(conversations) ? conversations : []));
      });

      unsubscribers.push(unsubscribe);
    });

    return () => unsubscribers.forEach((unsub) => unsub());
  }, [allEmployees, dbUser?.details?.authority]);

  // employee location listener
  useEffect(() => {

    const iata = dbUser.details.authority;
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    const employeeLocationsRef = collection(
      firestore,
      "employeesLocations",
      iata,
      formattedDate
    );

    const unsubscribe = onSnapshot(employeeLocationsRef, (snapshot) => {
      const updatedEmployeeLocations = [];

      snapshot.forEach((doc) => {
        updatedEmployeeLocations.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      dispatch(setEmployeeLocations(updatedEmployeeLocations));
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    let updatedArrivalsTaskList = [];
    let updatedDeparturesTaskList = [];
    let updatedBreakTaskList = [];

    const taskCollectionRef = collection(firestore, "tasks");
    const date = getDate(timelineDate);                              // Format date as YYYY-MM-DD

    const arrivalQuery = query(
      taskCollectionRef,
      where("flightInformation.arrivalAirport", "==", dbUser.details.authority),
      where("flightInformation.flightTime", ">=", `${date}T00:00:00`),
      where("flightInformation.flightTime", "<", `${date}T23:59:59`)
    );

    const departureQuery = query(
      taskCollectionRef,
      where("flightInformation.departureAirport", "==", dbUser.details.authority),
      where("flightInformation.flightTime", ">=", `${date}T00:00:00`),
      where("flightInformation.flightTime", "<", `${date}T23:59:59`)
    );

    const breakTasksQuery = query(
      taskCollectionRef,
      where("breakTaskInformation.airport", "==", dbUser.details.authority),
      where("breakTaskInformation.breakTaskDate", "==", `${date}`)
    );

    const handleSnapshot = (snapshot, tasksArr) => {
      tasksArr.length = 0; // Clear existing entries
      snapshot.forEach((doc) => {
        let taskData = doc.data();
        //check if the unplanned tasks auto accept is switched on to change the pending task status and accept the task
        if (taskData?.pending && autoAcceptUnplannedTask && !taskData?.isBreakTask) {
          dispatch(
            acceptUnplannedTask({
              ...taskData,
              pending: false,
            })
          ).then((res) => {
            taskData = {
              ...taskData,
              pending:
                res?.meta?.requestStatus === "fulfilled" ? false : true,
            };
          });
        };
        // check if the preBoard switch is turned off don't show the isEstimatedBooking and combinedBooking tasks 
        if (!preBoard && taskData?.isEstimatedBooking || !preBoard && taskData?.combinedBooking) return
        tasksArr.push(taskData);
      });
    };
    const unsubscribeArrival = onSnapshot(arrivalQuery, (snapshot) => {
      handleSnapshot(snapshot, updatedArrivalsTaskList);
      // Update the arrivals task list once arrivals snapshot is processed
      dispatch(updateArrivalsTaskList([...updatedArrivalsTaskList]));
    });

    const unsubscribeDeparture = onSnapshot(departureQuery, (snapshot) => {
      handleSnapshot(snapshot, updatedDeparturesTaskList);
      // Update the departures task list once departures snapshot is processed
      dispatch(updateDeparturesTaskList([...updatedDeparturesTaskList]));
    });

    const unsubscribeBreakTasks = onSnapshot(breakTasksQuery, (snapshot) => {
      handleSnapshot(snapshot, updatedBreakTaskList);
      // Update the departures task list once departures snapshot is processed
      dispatch(updateBreakTaskList([...updatedBreakTaskList]));
    });

    return () => {
      unsubscribeDeparture();
      unsubscribeArrival();
      unsubscribeBreakTasks()
    };
  }, [timelineDate, preBoard, deleteTaskStatus]);

  // pax location listener
  useEffect(() => {
    const paxLocationsRef = collection(firestore, "paxLocations");

    const year = new Date().getFullYear();
    const month = String(new Date().getMonth() + 1).padStart(2, '0');
    const day = String(new Date().getDate()).padStart(2, '0');
    const locationsQuery = query(
      paxLocationsRef,
      where("iata", "==", dbUser.details.authority),
      where('paxDepartureDate', '==', `${year}-${month}-${day}`),
    );

    const unsubscribe = onSnapshot(locationsQuery, (snapshot) => {
      const updatedLocationsList = [];
      snapshot.forEach((doc) => {
        const locationsData = doc.data();

        updatedLocationsList.push(locationsData);
      });
      dispatch(setPaxLocations(updatedLocationsList));
    });

    return () => unsubscribe();
  }, []);

  // // update the task list whenever the arrivals TaskList and departures TaskList changes
  useEffect(() => {
    let tempArrivals = Array.isFullArray(arrivalsTaskList) ? arrivalsTaskList : [];
    let tempDepartures = Array.isFullArray(departuresTaskList) ? departuresTaskList : [];
    let tempBreakTask = Array.isFullArray(breakTaskList) ? breakTaskList : [];
    dispatch(updateTaskList([...tempArrivals, ...tempDepartures, ...tempBreakTask]));
    dispatch(setDashboardTaskList([...tempArrivals, ...tempDepartures]))

  }, [arrivalsTaskList, departuresTaskList, breakTaskList])

  // get bookings by the booking type filter(all ,arrivals, departuers)
  useEffect(() => {
    handelGetBookings();
    handelGetFlights();
  }, [timelineDate]);

  // new job listener
  useEffect(() => {
    // if new job we need to show job confirmation modal
    if (sliceShowConfirmationModal) {
      setConfirmChangeModal(true);
    } else {
      // setConfirmChangeModal(false);
    }
  }, [sliceShowConfirmationModal]);

  useEffect(() => {
    if (deleteTaskStatus == 'succeeded') {
      dispatch(resetAllMenuContext());
      dispatch(resetDeleteFlags());
    }
  }, [deleteTaskStatus])

  useEffect(() => {
    if (updateEmployeeStatus === "succeeded" || updateEmployeeStatus === "failed") {
      dispatch(resetUpdateEmployeeStatus())
    }
  }, [updateEmployeeStatus]);

  useEffect(() => {
    if (setBookingLocationStatus == "succeeded" || paxCheckOutStatus == "succeeded" || unRejectPaxStatus == "succeeded") {
      handelGetBookings();
    }
  }, [setBookingLocationStatus, paxCheckOutStatus, unRejectPaxStatus]);

  useEffect(() => {
    if (dbUser?.details?.authority) {
      if (dbUser?.details?.authority == 'JER') {
        dispatch(setShowAllFlights(true))
      }
    }
  }, [dbUser])
  //#endregion

  //#region scrollable functions
  const scrollableDivRef = useRef(null); // reference to employee list
  const jobListRef = useRef(null); // reference to job list
  const disableScrollSync = useRef(false);  // ref to disable handleEmployeeListScroll and handleJobListScroll when search auto scroll in timelineJobs is working 

  // move job list when employee list is scrolled
  const handleEmployeeListScroll = () => {
    if (disableScrollSync.current) return; // prevent sync during `scrollIntoView()`

    jobListRef.current.scrollLeft = event.target.scrollLeft;
  };

  // move employee list when job list is scrolled
  const handleJobListScroll = () => {
    if (disableScrollSync.current) return; //  prevent sync during `scrollIntoView()`

    scrollableDivRef.current.scrollLeft = event.target.scrollLeft;
  };

  // Function to scroll to a specific point
  const scrollToPosition = () => {

    // Calculate the desired scroll position (in pixels)
    let columnWidth = EmployeeInformationColumnWidthRaw;

    // calculate current hour
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const currentSecond = new Date().getSeconds();

    let desiredScrollPosition = columnWidth * currentHour;

    const minuteWidth = columnWidth / 60;   // calculate the width of a minute on the timeline
    const secondWidth = minuteWidth / 60;   // calculate the width of a second on the timeline

    desiredScrollPosition += minuteWidth * currentMinute;

    desiredScrollPosition += secondWidth * currentSecond + 5;

    const scrollableDiv = scrollableDivRef.current;

    // Scroll to the desired position
    if (scrollableDiv) {
      scrollableDiv.scrollLeft = desiredScrollPosition;
    }
  };

  //#endregion

  //#region resizable controllers

  const timelineMinimumHeight = 600;

  const [dimensions, setDimensions] = useState({
    width: window.width,
    height: timelineMinimumHeight,
  });

  // Handle resize event
  const onResize = (event, { size }) => {
    setDimensions({
      width: size.width,
      height: size.height,
    });
  };

  //#endregion

  //#region timeline height monitor
  const timelineRef = useRef(null)
  const locationsRef = useRef(null)

  // set location height to match timeline job height
  useEffect(() => {
    // validate
    if (!timelineRef.current || !locationsRef.current) return;
    setTimelineHeight(timelineRef.current.clientHeight)
  }, [timelineRef.current?.clientHeight]);

  useEffect(() => {
    const isTouchScreenDevice = () => {
      try {
        document.createEvent('TouchEvent');
        return true;
      } catch (e) {
        return false;
      }
    }

    setTouchScreen(isTouchScreenDevice());
  }, []);

  const handleClickTimelineSpace = () => {
    if (showTimelineSidebar) dispatch(setShowTimelineSidebar(false))
  }
  //#endregion

  return (
    <div style={{ backgroundColor: usedTheme.BACKGROUND_COLOR }} >

      {/* Global tooltip */}
      <ToolTippy selectors={['[data-tippy-content]']} />

      {showTimelineSidebar && <TimelineSidebar />}

      {layout == 'default' ?
        <TimelineContainer onClick={handleClickTimelineSpace}>

          {/* header back button / date range picker / booking filter*/}
          <TimelineTitles />

          {/* timeline container */}
          <Row style={{ width: dimensions.width, display: 'flex' }}>

            {/* timeline */}
            <Col xs={touchScreen ? 9 : 10} ref={timelineRef} className="box" style={{ flex: 1 }}>

              <Row style={{}}>
                <TimelineCard>

                  {/* toolbar */}
                  <TimelineToolbar />

                  {/* timeline contents */}
                  <TimelineContentContainer devRef={scrollableDivRef} onDevScroll={handleEmployeeListScroll} maxHeight={'100%'}>

                    {/* hour number display */}
                    {thirtyMinLayout ? <TimelineThirtyMinHourRow /> : <TimelineHourRow />}

                    {/* listing of each employee timeline row */}
                    <EmployeeList clickedColumn={clickedColumn} setClickedColumn={setClickedColumn} paginationHeigh={dimensions.height + 'px'} setDimensions={setDimensions} />

                  </TimelineContentContainer>
                </TimelineCard>
              </Row>

              {/* filtering toolbar */}
              <Row className='mt-2' style={{}}>
                <JobListToolbar setShowCreateModal={(val) => { setShowCreateModal(val) }} handelGetBookings={handelGetBookings} handelGetFlights={handelGetFlights} />
              </Row>

              {/* job list */}
              <Row className="mt-2" style={{}}>
                <JobListContainer devRef={jobListRef} onDevScroll={handleJobListScroll} >
                  <TimelineJobs disableScrollSync={disableScrollSync} />
                </JobListContainer>
              </Row>
            </Col>

            {/* locations */}
            {toggleAirportLocations &&
              <Col ref={locationsRef} style={{ flex: 1, maxHeight: timelineHeight, height: timelineHeight }}>

                {/* old implementation */}
                {dbUser?.details?.authority == 'JER' ?
                  <AirportLocations
                    height={timelineHeight ? timelineHeight : "1000px"}
                    setToggleAirportLocations={(val) => dispatch(setExpandLocations(val))}
                  />
                  :
                  <>
                    {/*new implementation */}
                    <NewAirportLocations
                      height={timelineHeight ? timelineHeight : "1000px"}
                      setToggleAirportLocations={(val) => dispatch(setExpandLocations(val))}
                    />
                  </>
                }</Col>
            }

            {!toggleAirportLocations &&
              <div style={{ width: Spacing.SCALE_80, padding: Spacing.SCALE_12 }} data-tippy-content="Show Locations">
                <Button variant={"outline-secondary"} onClick={() => { dispatch(setExpandLocations(true)) }}>
                  <BsLayoutSidebarInsetReverse color={'white'} size={Spacing.SCALE_18} />
                </Button>
              </div>
            }

          </Row>

        </TimelineContainer>
        :
        <TimelineContainer onClick={handleClickTimelineSpace}>

          {/* header back button / date range picker / booking filter*/}
          <TimelineTitles />

          {/* timeline container */}
          <Row style={{ width: dimensions.width, display: 'flex' }}>

            {/* flight list */}
            <Col xs={5} style={{ borderTopStyle: 'solid', borderTopWidth: '5px', borderTopColor: Colors.PRM_LIGHT_BLUE, }}>

              {/* job list toolbar */}
              <Row className='mt-1' style={{ marginBottom: Spacing.SCALE_12 }}>
                <div style={{ flex: 1, display: 'flex' }} />
                <div style={{ flex: 1, display: 'flex' }}>
                  <JobListToolbar setShowCreateModal={(val) => { setShowCreateModal(val) }} handelGetBookings={handelGetBookings} handelGetFlights={handelGetFlights} hideFlightFilter={false} hideEmployeePagination={true} />
                </div>
              </Row>

              {/* job list */}
              <Row className="mt-2" style={{}}>
                <JobListContainer devRef={jobListRef} onDevScroll={handleJobListScroll} >
                  <TimelineJobs disableScrollSync={disableScrollSync} />
                </JobListContainer>
              </Row>

            </Col>

            {/* timeline */}
            <Col xs={5} ref={timelineRef} className="box" style={{ flex: 1, }}>

              <TimelineCard>

                {/* toolbar */}
                <TimelineToolbar />

                {/* timeline contents */}
                <TimelineContentContainer devRef={scrollableDivRef} onDevScroll={handleEmployeeListScroll} maxHeight={'100%'}>

                  {/* hour number display */}
                  {thirtyMinLayout ? <TimelineThirtyMinHourRow /> : <TimelineHourRow />}

                  {/* listing of each employee timeline row */}
                  <EmployeeList clickedColumn={clickedColumn} setClickedColumn={setClickedColumn} paginationHeigh={dimensions.height + 'px'} setDimensions={setDimensions} />

                </TimelineContentContainer>

              </TimelineCard>

              {/* filtering toolbar */}
              <Row className='mt-2' style={{}}>
                <JobListToolbar setShowCreateModal={(val) => { setShowCreateModal(val) }} handelGetBookings={handelGetBookings} handelGetFlights={handelGetFlights} hideFlightFilter={true} />
              </Row>

              {/* job list */}
              <Row className="mt-2" style={{}}>
                <JobListContainer devRef={jobListRef} onDevScroll={handleJobListScroll} >
                  <TimelineJobs disableScrollSync={disableScrollSync} />
                </JobListContainer>
              </Row>
            </Col>

            {/* locations */}
            {toggleAirportLocations &&
              <Col ref={locationsRef} style={{ flex: 1, maxHeight: timelineHeight, height: timelineHeight }}>

                {/* old implementation */}
                {dbUser?.details?.authority == 'JER' ?
                  <AirportLocations
                    height={timelineHeight ? timelineHeight : "1000px"}
                    setToggleAirportLocations={(val) => dispatch(setExpandLocations(val))}
                  />
                  :
                  <>
                    {/*new implementation */}
                    {/* <div style={{ flex: 1, border: '1px solid' }}> */}
                    <NewAirportLocations
                      height={timelineHeight ? timelineHeight : "1000px"}
                      setToggleAirportLocations={(val) => dispatch(setExpandLocations(val))}
                    />
                    {/* </div> */}
                  </>
                }</Col>
            }


          </Row>

        </TimelineContainer>
      }

      {/* job confirmation modal */}
      <ActionsModal
        show={confirmChangeModal}
        handleClose={closeConfirmationModal}
        title="Create Task"
        subtitle={"To create a task for an employee, select the PRM booking that you want to assign, set a pickup and drop off location and add notes if required."}
        isTimeline={true}
      >
        <JobConfirmation
          taskConfirmed={() => {
            setConfirmChangeModal(false);
            dispatch(resetSelectedTask());
          }}
          taskRejected={cancelTask}
          clickedColumn={clickedColumn}
          setClickedColumn={setClickedColumn}
        />
      </ActionsModal>

      {/* create booking Modal */}
      <ActionsModal show={showCreateModal} handleClose={closeCreateBookingModal} title="Create Booking" minWidth="1100px" maxWidth="1100px" isTimeline={true}>
        <BookingForm />
      </ActionsModal>

      {/* edit booking Modal */}
      <ActionsModal show={showEditModal} handleClose={closeEditBookingModal} title={modalType === "BOOKING" ? "Edit Booking" : "Edit Task"} subtitle={"Edit Passenger Information"} minWidth="500px" maxWidth="500px" isTimeline={true}>
        <EditTimelineBooking onClose={closeEditBookingModal} />
      </ActionsModal>

      {/* menu context */}
      {showMenuContext && (
        <MenuContextContainer
          style={{ position: "absolute", left: points.x, top: points.y }}
        >
          <JobActionMenu />
        </MenuContextContainer>
      )}

      {/* Flights context */}
      {flightContext && (
        <MenuContextContainer
          style={{ position: "absolute", left: flightContextPoints?.x, top: flightContextPoints?.y }}
        >
          <FlightActionMenu />
        </MenuContextContainer>
      )}

      {paxMenuContextModal && (
        <MenuContextContainer style={{ position: "absolute", left: menuLocationPoints.x, top: menuLocationPoints.y }} >
          <LocationContextMenu passenger={passenger} />
        </MenuContextContainer>
      )}

      {/* view task Modal*/}
      <ActionsModal
        show={viewTask}
        handleClose={closeViewTaskModal}
        title="Task Information"
        subtitle={"View information on the selected task, employee and the task"}
        isTimeline={true}
      >
        <ViewJob onClose={closeViewTaskModal} />
      </ActionsModal>

      {/* passenger check in Modal */}
      <ActionsModal show={paxCheckInModal}
        handleClose={closePaxCheckInModal}
        title={`${paxLocation ? 'Set Passenger Location' : 'Passenger Check in'}`}
        subtitle={paxLocation ? "Set the passenger location" : "Select the check in location, confirm the assistance required and add any notes if required."}
        isTimeline={true}
      >
        <EditTimelineBooking
          onClose={closePaxCheckInModal}
          locationSelectTitle={paxLocation ? "Passenger Location" : "Check in Location (Required)"}
          btnTitle={paxLocation ? "Set Location" : "Check In"}
          placeholder={paxLocation ? "Choose Pax Location..." : "Choose Check in Location..."}
          forCheckIn={true} />

      </ActionsModal>

      {/* delete booking Modal */}
      <ActionsModal
        show={ShowDeleteBookingModal}
        handleClose={closeDeleteBookingModal}
        title="Delete PRM Booking"
        subtitle={"To delete a PRM Booking, please click the 'Delete PRM Booking' button below. This action cannot be undone."}
        isTimeline={true}
      >
        <DeleteBooking onClose={closeDeleteBookingModal} />
      </ActionsModal>

      {/* view task Modal */}
      <ActionsModal show={showBreakTaskModal} handleClose={closeBreakTaskModal} title="Create Break Task" minWidth="500px" maxWidth="500px" isTimeline={true}>
        <CreateBreakTask onClose={closeBreakTaskModal} />
      </ActionsModal>

      {/* Flight List Modal */}
      <ActionsModal show={showFlightList} handleClose={closeFlightListModal} title="Flight List" subtitle="Select the passenger you are collecting from the list of passengers on the flight" minWidth="445px" maxWidth="445px" isTimeline={true}>
        <FlightList onClose={closeFlightListModal} />
      </ActionsModal>

      {/* Show Flight Modal */}

      <ActionsModal show={!Object.isObjectEmpty(selectedFlightToView)} handleClose={closeViewFlightModal} title={`Flight ${selectedFlightToView?.flightNumber}`} minWidth="445px" maxWidth="445px" isTimeline={true} >
        <ViewFlight onClose={closeViewFlightModal} />
      </ActionsModal>

      <ActionsModal show={!Object.isObjectEmpty(selectedForChat)} handleClose={closeSelectedForChatModal} title={`${selectedForChat?.employee?.title} Chat`} minWidth="445px" maxWidth="445px" isTimeline={true} >
        <EmployeeChat />
      </ActionsModal>

      <ActionsModal show={!Object.isObjectEmpty(selectedFlightToChat)} handleClose={closeSelectedFlightToChatModal} title={`${selectedFlightToChat?.flightNumber} Chat`} minWidth="445px" maxWidth="445px" isTimeline={true} >
        <FlightChat />
      </ActionsModal>

      {showToast ?
        <div style={{
          position: 'fixed', top: 0, right: 0, zIndex: 9999,
          // width:'350px', 
          // height: '150px',
          backgroundColor: 'white',
          //  borderStyle: 'solid', borderWidth: 1
        }}>
          <CustomToast />
        </div>
        : null}

    </div>
  );

};

export default TimelineComponent;
